import { PageProps } from "gatsby";
import React, { useState } from "react";
import { css, styled } from "twin.macro";

import Button from "../../components/common/Button";
import Container from "../../components/common/Container";
import Image from "../../components/common/Image";
import IntegrationDetail from "../../components/common/IntegrationDetail";
import SvgObject from "../../components/elements/SvgObject";
import BoldOfferModal from "../../components/integrations/BoldOfferModal";
import offloadCancellation from "../../components/integrations/features/offloadCancellation";
import targetedIncentives from "../../components/integrations/features/targetedIncentives";

const IntegrationImage = styled(SvgObject)`
  width: 100%;
  max-width: 600px;
`;

const Bold: React.FunctionComponent<PageProps> = ({ location }) => {
  const [boldModalIsOpen, setBoldModalIsOpen] = useState(false);

  const params = new URLSearchParams(location.search);
  const ref = params.get("ref");

  return (
    <IntegrationDetail
      seoTitle="Prevent churn automatically with Bold"
      seoDescription="Connect Bold to unlock advanced churn metrics, powerful customer segmentation, automated offers and recovered revenue tracking."
      title="Bold"
      description="Connect Bold to unlock advanced churn metrics, powerful customer segmentation, automated offers and recovered revenue tracking."
      logo={
        <Image
          src={
            require("../../assets/images/integrations/logos/bold-logo.svg")
              .default
          }
          alt=""
          style={{ maxWidth: "200px", top: "-20px", position: "relative" }}
        />
      }
      howItWorksDescription="Connect Bold to power your automated retention. ProsperStack can automatically present and apply targeted offers including coupons and subscription pauses with your Bold account."
      howItWorksImage={
        <IntegrationImage
          data={
            require("../../assets/images/integrations/bold-integration.svg")
              .default
          }
          width={675}
          height={503}
        />
      }
      features={[
        "Connect to ProsperStack with your Bold API token",
        "Process cancellations and apply offers automatically",
        "Get detailed churn and recovered revenue reports with your Bold data",
        "Supported offers include coupons and subscription pauses",
      ]}
      extraFeatures={[targetedIncentives("Bold"), offloadCancellation("Bold")]}
      aboveHero={
        ref === "bold" ? (
          <>
            <BoldOfferModal
              isOpen={boldModalIsOpen}
              onClose={() => setBoldModalIsOpen(false)}
            />
            <Container tw="mt-[30px] mb-[-20px]">
              <div
                tw="text-white font-semibold rounded-xl px-6 py-4 flex items-center"
                css={css`
                  background: linear-gradient(
                    274deg,
                    #e60046 8.9%,
                    #e82d66 99.65%
                  );
                `}
              >
                <div>
                  New Bold customers get 50% off their first month of
                  ProsperStack!
                </div>
                <div tw="ml-auto">
                  <Button
                    tw="bg-transparent! text-white! border-white! hover:bg-[#CF0F45]!"
                    onClick={() => setBoldModalIsOpen(true)}
                  >
                    Claim offer
                  </Button>
                </div>
              </div>
            </Container>
          </>
        ) : undefined
      }
    />
  );
};

export default Bold;
